import React from "react";
import FeatureBox from "../Common/FeatureBox2";
import project1 from "../../assets/images/salary/intelligence/1project.png";
import situation2 from "../../assets/images/salary/intelligence/2situation.png";
import adjust3 from "../../assets/images/salary/intelligence/3adjust.png";
import item4 from "../../assets/images/salary/intelligence/4item.png";

const Intelligence = () => {
  const features = [
    {
      title: "多种薪酬方案并行",
      descriptions: ["预置薪酬方案：国家薪酬方案，医院薪酬方案，集团薪酬方案，可直接修改套用", "多薪酬并行：支持一个企业实行多套薪资结构及核算方法，可自定义预设方案"],
      images: project1,
    },
    {
      title: "定薪、调薪批量快速",
      descriptions: ["新员工定薪：根据招聘笔试考核结果批量定薪", "调岗调薪：员工调岗流程完自动调薪与核算", "离职停薪：离职人员自动生成停薪报表，一键审批"],
      images: situation2,
    },
    {
      title: "算薪算税流程一体化",
      descriptions: ["发薪表自动扣除社保、公积金、个税。个税金额自动核算，支持年度汇算，按月扣除等多种灵活个税扣除方式"],
      images: adjust3,
    },
    {
      title: "全国通用社保",
      descriptions: ["实时更新：社保数据对接各属地社保网厅数据，一键生成各类社保公积金数据", "跨区域社保：全国所有的地市县以及农村社保基础均涵盖"],
      images: item4,
    },
  ];
  return (
    <section className="history-area pt-70 pb-70 bg-fafafb">
      <div className="container">
        <div className="section-title">
          <h2>发薪、算薪智能快捷</h2>
          <p>薪资专业人员不再做核算工作，系统核算准确性更高。HR只需对系统数据正确性进行审核，然后做出人力成本分析，为企业降本增效。</p>
        </div>
        <div className="d-flex flex-column">
          {features.map((feature, key) => (
            <React.Fragment key={key}>
              <FeatureBox {...feature} reverse={key % 2 === 1} className="my-5" />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Intelligence;
